// ProductDetail.js

import React, {Component} from 'react';
import { Button, Form , Table , Container, Row, Col ,  ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';
const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];

export default class ProductImageMapDetail extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onChange: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        console.log('constructor',this.props.item);

        this.state = {
            answervisible : false,
            enable : true,
            item : this.props.item,
        };
    }
        
    componentWillReceiveProps(nextProps){
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState( { item : nextProps.item  } );
    }

    handleChangeWidth(event) {
        var item = this.state.item;
        item.WIDTH = event.target.value;
        this.setState({ item: item });
    }

    handleChangeHTML(event) {
        var item = this.state.item;
        item.MAPHTML = event.target.value;
        this.setState({ item: item });
    }

    handleChangeJSON(event) {
        var item = this.state.item;
        item.MAPJSON = event.target.value;
        this.setState({ item: item });
    }
    
    handleOnChange(event) {
        this.props.onChange(this.state.item),
        event.preventDefault();
    }

    render(){
        return (
            <div className="box" >
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                    <Button variant="primary" onClick={this.handleOnChange.bind(this)}>저장</Button>
                    {/* <Button variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button> */}
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group as={Col}  controlId="exampleForm.ControlInput1">
                            <Form.Label>이미지맵파일</Form.Label>
                            <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.IMAGENAME}  />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group as={Col}  controlId="exampleForm.ControlInput1">
                            <Form.Label>이미지 Width(px)</Form.Label>
                            <Form.Control type="number" placeholder="가로사이즈(px)" value={this.state.item.WIDTH} onChange={this.handleChangeWidth.bind(this)} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>내용(원본)</Form.Label>
                            <Form.Control as="textarea" rows="20" value={this.state.item.MAPHTML} onChange={this.handleChangeHTML.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>내용(자동변환)</Form.Label>
                            <Form.Control as="textarea" rows="20" value={this.state.item.MAPJSON} onChange={this.handleChangeJSON.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>
 
            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductImageMapDetail.js